<template>
  <form-group class="ma-0 pa-0">
    <v-row class="pt-3">
      <v-col cols="12">
        <v-tabs
          v-model="tabs"
          vertical
        >
          <v-tab>
            Transferência
          </v-tab>
          <v-tab>
            Depósito
          </v-tab>

          <v-tabs-items
            v-model="tabs"
            vertical
          >
            <v-tab-item>
              <users-transfer-receipt-list
                v-model="clientId"
              />
            </v-tab-item>

            <v-tab-item>
              <user-deposit-receipts-list
                v-model="clientId"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import UsersTransferReceiptList from '@/app/users/components/tables/UserTransferReceiptList.vue';
import UserDepositReceiptsList from 'App/users/components/tables/UserDepositReceiptsList.vue';

export default {
  name: 'UserReceiptsContent',
  components: { FormGroup, UsersTransferReceiptList, UserDepositReceiptsList },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    tabs: null,
  }),
  computed: {
    clientId() {
      return this.value;
    },
  },
};
</script>
